import React from 'react';
import { HandDrawnButton } from '../../../components/shared/HandDrawnButton/HandDrawnButton';
import './FeathersVideoFooter.css';

interface FeathersVideoFooterProps {
  quote: string;
  linkText?: string;
  linkUrl?: string;
}

const FeathersVideoFooter: React.FC<FeathersVideoFooterProps> = ({ 
  quote, 
  linkText = 'learn more',
  linkUrl = '/our-story' 
}) => {
  const handleButtonClick = () => {
    if (linkUrl) {
      window.location.href = linkUrl;
    }
  };

  return (
    <section className="feathers-video-footer">
      <div className="feathers-video-content">
        <h2>{quote}</h2>
        <HandDrawnButton
          text={linkText}
          onClick={handleButtonClick}
          variant="brand"
          color="awasi"
          animation="stroke-to-fill"
          size="normal"
          className="feathers-video-button"
        />
      </div>
    </section>
  );
};

export default FeathersVideoFooter;